import React, { useState, useEffect } from 'react';
import Theme from '../theme';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/home/contact.json`;

    const [content, setContent] = useState({
        labName: 'Blockchain & Robotics (PLANR) Lab',
        department: 'Department of Computer Science & Engineering',
        location: 'R-502, 5th Floor, Block 3',
        phone: '+91 612 3028889'
    });

    useEffect(() => {
        // GET Payload
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div className="Name-Heading row">
            <div className="theme-box">
                <Theme />
            </div>
            <div className="header-logo col-sm-6 col-12">
                <img alt="planr-logo" src={`${process.env.PUBLIC_URL}/_static/logo-white.svg`} />
            </div>

            <div className="contact-box col-sm-6 d-none d-sm-block">
                <h6>{content.labName}</h6>
                <h6>{content.department}</h6>
                <p>
                    <i className="fas fa-map-marked-alt" /> {content.location}
                    <br />
                    <i className="fas fa-phone-alt" /> {content.phone}
                </p>
            </div>
            <div className="col-12 d-block d-sm-none">&nbsp;</div>
        </div>
    );
};

export default Component;
